import type { CompanyProfile } from '@/types'

interface BankBlockProps {
	company?: CompanyProfile | null
}

/**
 * Top-of-invoice bank receiver block — two-column bordered grid like a paper
 * payment form: bank name + БИК / Сч.№ / ИНН / КПП / receiver name.
 */
export function BankBlock({ company }: BankBlockProps) {
	const placeholder = '—'
	return (
		<div className="grid grid-cols-[1fr_auto_1fr] border border-(--color-foreground) text-xs leading-tight">
			{/* Bank name row */}
			<div className="col-span-3 border-b border-(--color-foreground) px-2 py-1">
				<div className="font-[500]">{company?.bank ?? placeholder}</div>
				<div className="mt-2 text-(--color-muted-foreground)">Банк получателя</div>
			</div>

			{/* ИНН + КПП | БИК */}
			<div className="border-r border-(--color-foreground) px-2 py-1">
				<span>ИНН&nbsp;&nbsp;{company?.inn ?? placeholder}</span>
				<span className="ml-6">КПП&nbsp;&nbsp;{company?.kpp ?? placeholder}</span>
			</div>
			<div className="border-r border-(--color-foreground) px-2 py-1">БИК</div>
			<div className="px-2 py-1">{company?.bik ?? placeholder}</div>

			{/* Receiver | Сч.№ */}
			<div className="row-span-2 border-t border-(--color-foreground) px-2 py-1">
				<div>{company?.name ?? placeholder}</div>
				<div className="mt-2 text-(--color-muted-foreground)">Получатель</div>
			</div>
			<div className="border-t border-r border-(--color-foreground) px-2 py-1">Сч.&nbsp;№</div>
			<div className="border-t border-(--color-foreground) px-2 py-1">{company?.corrAccount ?? placeholder}</div>
			<div className="border-t border-r border-(--color-foreground) px-2 py-1">Сч.&nbsp;№</div>
			<div className="border-t border-(--color-foreground) px-2 py-1">{company?.bankAccount ?? placeholder}</div>
		</div>
	)
}
